import {ADMIN_ROUTE_CONSTANTS} from '@shared/constants/routes';
import {MenuItem} from 'primeng/api';

const adminBase = `/${ADMIN_ROUTE_CONSTANTS.path}`;

export const INTELLIGENCE: MenuItem = {
  label: ADMIN_ROUTE_CONSTANTS.intelligence.data.breadcrumb,
  icon: ADMIN_ROUTE_CONSTANTS.intelligence.data.icon,
  hasSubmenu: true,
  expanded: false,
  items: [
    {
      label: ADMIN_ROUTE_CONSTANTS.intelligence.financialReports.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.intelligence.financialReports.data.icon,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.intelligence.path}/${ADMIN_ROUTE_CONSTANTS.intelligence.financialReports.path}`
    },
    {
      label: ADMIN_ROUTE_CONSTANTS.intelligence.incidentReports.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.intelligence.incidentReports.data.icon,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.intelligence.path}/${ADMIN_ROUTE_CONSTANTS.intelligence.incidentReports.path}`
    },
    {
      label: ADMIN_ROUTE_CONSTANTS.intelligence.communityReports.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.intelligence.communityReports.data.icon,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.intelligence.path}/${ADMIN_ROUTE_CONSTANTS.intelligence.communityReports.path}`
    },
    {
      label: ADMIN_ROUTE_CONSTANTS.intelligence.kpis.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.intelligence.kpis.data.icon,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.intelligence.path}/${ADMIN_ROUTE_CONSTANTS.intelligence.kpis.path}`
    },
    {
      label: ADMIN_ROUTE_CONSTANTS.intelligence.biIntegration.data.breadcrumb,
      icon: ADMIN_ROUTE_CONSTANTS.intelligence.biIntegration.data.icon,
      routerLink: `${adminBase}/${ADMIN_ROUTE_CONSTANTS.intelligence.path}/${ADMIN_ROUTE_CONSTANTS.intelligence.biIntegration.path}`
    }
  ]
};
